<div class="content">

  <!-- Start Content-->
  <!-- <div class="container-fluid"> -->
      
      <div class="row mx-0">
          <div class="col-md-12 px-0">
              
              <div class="">
                  
                  <h2 class="page-title">
                    <a href="javascript:void(0);" (click)="back();" class="btn-xs casino-back">
                      back
                    </a>
                    <!-- {{gameName}} -->
                   <small> {{userData?.username}} </small>
                  </h2>

                  <div class="card">
                      <div class="card-body cc-ui" *ngIf="iframeUrl">
                          
                        <iframe scrolling="yes" [src]='iframeUrl | safeURL' allowfullscreen="true" title="game" id="casino-link"></iframe>
                        <app-loader *ngIf="isLoad"></app-loader>

                      </div>
                  </div>
              </div>

          </div> <!-- end col-->
      </div>
      <!-- end row -->

  <!-- </div> -->
  <!-- container -->

</div> <!-- content -->


